
import { Link } from 'react-router-dom';
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const BlogSeoBlock = () => {
  const { ref: contentRef, isVisible: contentVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: topicsRef, isVisible: topicsVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation({ threshold: 0.2 });

  const relatedTopics = [
    { label: 'Desguace Gavá', icon: 'ri-car-line' },
    { label: 'Vender Coche Siniestrado', icon: 'ri-money-euro-circle-line' },
    { label: 'Chatarra Coches Gavá', icon: 'ri-recycle-line' },
    { label: 'Grúa Gratis Gavá', icon: 'ri-truck-line' },
    { label: 'Baja Vehículo DGT', icon: 'ri-file-text-line' },
    { label: 'Piezas Segunda Mano', icon: 'ri-settings-3-line' },
    { label: 'Reciclaje Vehículos', icon: 'ri-leaf-line' },
    { label: 'Desguace Baix Llobregat', icon: 'ri-map-pin-line' },
    { label: 'Siniestro Total Seguro', icon: 'ri-shield-check-line' },
    { label: 'Averías Caras Coche', icon: 'ri-tools-line' },
    { label: 'Herencia Vehículo', icon: 'ri-file-list-3-line' },
    { label: 'Indemnización Accidente', icon: 'ri-hand-coin-line' },
  ];

  return (
    <section className="py-16 px-6 lg:px-12 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div ref={contentRef} className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div
            className={`transition-all duration-700 ${
              contentVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}
          >
            <h4 className="text-xl font-bold text-gray-900 mb-4">
              <a href="/blog">Tu Guía sobre Desguaces en Gavá</a>
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              En el <strong>blog de Desguace Gavá</strong> encontrarás toda la información que necesitas sobre la venta de coches siniestrados, averiados y para chatarra en Gavá y la comarca del Baix Llobregat. Nuestros artículos están escritos por profesionales del sector con más de <strong>15 años de experiencia en desguaces en Gavá</strong>.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed">
              Desde guías prácticas sobre cómo vender tu coche al mejor precio, hasta información actualizada sobre normativas de la DGT, precios de chatarra y servicios de <strong>retirada gratuita de vehículos en Gavá</strong>. Todo lo que necesitas saber antes de llevar tu coche al desguace.
            </p>
          </div>

          <div
            ref={topicsRef}
            className={`transition-all duration-700 delay-200 ${
              topicsVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
            }`}
          >
            <h4 className="text-xl font-bold text-gray-900 mb-4">
              <a href="/blog">Temas Populares</a>
            </h4>
            <div className="flex flex-wrap gap-3">
              {relatedTopics.map((topic, index) => (
                <Link
                  key={topic.label}
                  to="/blog"
                  className={`inline-flex items-center space-x-2 px-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm text-gray-700 hover:border-emerald-400 hover:text-emerald-700 hover:bg-emerald-50 transition-all cursor-pointer duration-500 ${
                    topicsVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
                  }`}
                  style={{ transitionDelay: `${300 + index * 50}ms` }}
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${topic.icon} text-emerald-600`}></i>
                  </div>
                  <span>{topic.label}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div
          ref={ctaRef}
          className={`mt-12 bg-emerald-700 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6 transition-all duration-700 ${
            ctaVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div>
            <h3 className="text-2xl font-bold text-white mb-2">¿Quieres vender tu coche en Gavá?</h3>
            <p className="text-emerald-100 text-sm">Presupuesto sin compromiso en menos de 2 horas. Recogida gratuita y pago inmediato.</p>
          </div>
          <a
            href="tel:+34932932913"
            className="inline-flex items-center space-x-2 bg-white text-emerald-700 hover:bg-gray-100 px-8 py-3.5 rounded-lg font-bold text-sm transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill"></i>
            <span>Llamar: 932 932 913</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BlogSeoBlock;
